import styled, { css } from 'styled-components';
import { colors, monokaiCommentColor } from 'global/colors';

export const EditorContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
      span.ace_comment {
        color: ${monokaiCommentColor};
      }
    `}
`;

export const SolutionButtonContainer = styled.span`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  padding-bottom: 3px;
  border-bottom: 1px solid ${colors.darkGray};
`;

export const CodeContainer = styled.div`
  width: 100%;
  height: calc(100% - ${({ smallScreenOffset }) => smallScreenOffset}px);
  overflow: hidden;
`;
